export default __webpack_public_path__ + "static/media/about2.7b267f30.jpeg";